import React from "react";
import key from "../../constants/key";

const Pgp = () => {
  return <pre style={{
    margin: "2rem",
    whiteSpace: "pre-wrap",
    fontFamily: "monospace",
    fontSize: "0.7rem",
    color: "#67e4e5",
    lineHeight: 1.4
  }}>{key}</pre>;
};

export default Pgp;
